{
	"transactionCardHeader": "Valider une transaction",
	"transactionCardDescriptionBold": "Vous souhaitez valider une transaction pour un projet quelconque ?",
	"transactionCardDescriptionRegular": "Si vous avez un numéro de transaction sous la main, vous pouvez le saisir ici et valider la transaction.",
	"showTransactionButton": "Afficher la transaction",
	"transactionLabel": "Numéro de transaction",
	"errors": {
		"transactionIdRequired": "Le numéro de transaction est obligatoire.",
		"transactionNotFound": "Transaction introuvable.",
		"transactionIdInvalid": "Numéro de transaction invalide."
	}
}
